export default "__VITE_ASSET__CXM9ohek__"